import React, { useEffect, useState } from 'react';
import api from '../api';

function Customers() {
  const [customers, setCustomers] = useState([]);
  const [form, setForm]       = useState({ name:'', phone:'', email:'', address:'', gstin:'' });
  const [editId, setEditId]   = useState(null);
  const [message, setMessage] = useState('');
  const [error, setError]     = useState('');
  const [search, setSearch]   = useState('');
  const [showForm, setShowForm] = useState(false);

  useEffect(() => { fetchCustomers(); }, []);

  const fetchCustomers = () => {
    api.get('/customers/').then(res => setCustomers(res.data || [])).catch(() => {});
  };

  const resetForm = () => {
    setForm({ name:'', phone:'', email:'', address:'', gstin:'' });
    setEditId(null); setShowForm(false);
  };

  const saveCustomer = () => {
    if (!form.name || !form.phone) {
      setError('பெயர் மற்றும் தொலைபேசி கட்டாயம்!'); return;
    }
    const req = editId
      ? api.put(`/customers/${editId}`, form)
      : api.post('/customers/', form);
    req.then(() => {
      setMessage(editId ? '✅ வாடிக்கையாளர் திருத்தப்பட்டது!' : '✅ வாடிக்கையாளர் சேர்க்கப்பட்டது!');
      setError(''); fetchCustomers(); resetForm();
      setTimeout(() => setMessage(''), 3000);
    }).catch(err => setError('❌ ' + (err.response?.data?.detail || err.message)));
  };

  const editCustomer = (c) => {
    setForm({ name:c.name, phone:c.phone, email:c.email||'', address:c.address||'', gstin:c.gstin||'' });
    setEditId(c.id); setShowForm(true); window.scrollTo(0,0);
  };

  const deleteCustomer = (id, name) => {
    if (!window.confirm(`"${name}" நீக்கவா?`)) return;
    api.delete(`/customers/${id}`)
      .then(() => { setMessage('✅ நீக்கப்பட்டது!'); fetchCustomers(); setTimeout(() => setMessage(''), 3000); })
      .catch(err => setError('❌ ' + (err.response?.data?.detail || err.message)));
  };

  const filtered = customers.filter(c =>
    c.name?.toLowerCase().includes(search.toLowerCase()) || c.phone?.includes(search)
  );

  return (
    <div style={s.page}>
      <div style={s.header}>
        <h1 style={s.title}>👥 வாடிக்கையாளர்கள்</h1>
        <button style={s.addBtn} onClick={() => { resetForm(); setShowForm(!showForm); }}>
          {showForm ? '✕ ரத்து செய்' : '➕ வாடிக்கையாளர் சேர்'}
        </button>
      </div>

      {message && <div style={s.success}>{message}</div>}
      {error && (
        <div style={s.err}>
          {error}
          <span style={{cursor:'pointer'}} onClick={() => setError('')}>✕</span>
        </div>
      )}

      {showForm && (
        <div style={s.form}>
          <h3 style={s.formTitle}>
            {editId ? '✏️ திருத்து' : '➕ புது'} வாடிக்கையாளர்
          </h3>
          <div style={s.grid}>
            <input style={s.input} placeholder="பெயர் *"
              value={form.name} onChange={e => setForm({...form, name:e.target.value})} />
            <input style={s.input} placeholder="📱 தொலைபேசி *" type="tel"
              value={form.phone} onChange={e => setForm({...form, phone:e.target.value})} />
            <input style={s.input} placeholder="மின்னஞ்சல்" type="email"
              value={form.email} onChange={e => setForm({...form, email:e.target.value})} />
            <input style={s.input} placeholder="GSTIN"
              value={form.gstin} onChange={e => setForm({...form, gstin:e.target.value})} />
            <input style={{...s.input, gridColumn:'span 2'}} placeholder="முகவரி"
              value={form.address} onChange={e => setForm({...form, address:e.target.value})} />
          </div>
          <div style={{display:'flex', gap:'10px'}}>
            <button style={s.saveBtn} onClick={saveCustomer}>
              {editId ? '✅ புதுப்பி' : '✅ சேமி'}
            </button>
            <button style={s.cancelBtn} onClick={resetForm}>ரத்து</button>
          </div>
        </div>
      )}

      <input style={s.search} placeholder="🔍 தேடுங்கள்..."
        value={search} onChange={e => setSearch(e.target.value)} />

      <div style={s.tableWrap}>
        <table style={s.table}>
          <thead>
            <tr style={s.thead}>
              <th style={s.th}>பெயர்</th>
              <th style={s.th}>தொலைபேசி</th>
              <th style={s.th}>மின்னஞ்சல்</th>
              <th style={s.th}>GSTIN</th>
              <th style={s.th}>செயல்</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr><td colSpan={5} style={s.empty}>வாடிக்கையாளர்கள் இல்லை!</td></tr>
            ) : filtered.map((c, i) => (
              <tr key={c.id} style={{backgroundColor: i%2===0?'white':'#f8f9fa'}}>
                <td style={s.td}><strong>{c.name}</strong></td>
                <td style={s.td}>
                  <a href={`https://wa.me/91${c.phone}`} target="_blank" rel="noreferrer"
                    style={{color:'#25D366', textDecoration:'none', fontWeight:'600'}}>
                    📱 {c.phone}
                  </a>
                </td>
                <td style={s.td}>{c.email || '—'}</td>
                <td style={s.td}>{c.gstin || '—'}</td>
                <td style={s.td}>
                  <button style={s.editBtn} onClick={() => editCustomer(c)}>✏️</button>
                  <button style={s.delBtn} onClick={() => deleteCustomer(c.id, c.name)}>🗑️</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const s = {
  page:{padding:'20px',maxWidth:'1100px',margin:'0 auto'},
  header:{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'20px'},
  title:{color:'#2c3e50',margin:0},
  addBtn:{background:'#2c3e50',color:'white',border:'none',padding:'10px 20px',borderRadius:'8px',cursor:'pointer',fontWeight:'600'},
  success:{background:'#e8f8f0',border:'1px solid #27ae60',color:'#27ae60',padding:'10px 14px',borderRadius:'8px',marginBottom:'14px',fontWeight:'600'},
  err:{background:'#fff0f0',border:'1px solid #e74c3c',color:'#e74c3c',padding:'10px 14px',borderRadius:'8px',marginBottom:'14px',display:'flex',justifyContent:'space-between'},
  form:{background:'#f9f9f9',border:'1px solid #ddd',borderRadius:'12px',padding:'20px',marginBottom:'20px'},
  formTitle:{color:'#2c3e50',marginBottom:'16px'},
  grid:{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',marginBottom:'14px'},
  input:{padding:'10px 12px',borderRadius:'8px',border:'1px solid #ddd',fontSize:'14px',width:'100%',boxSizing:'border-box'},
  saveBtn:{background:'#27ae60',color:'white',border:'none',padding:'10px 24px',borderRadius:'8px',cursor:'pointer',fontWeight:'600'},
  cancelBtn:{background:'#ddd',color:'#555',border:'none',padding:'10px 24px',borderRadius:'8px',cursor:'pointer',fontWeight:'600'},
  search:{width:'100%',padding:'10px 14px',borderRadius:'8px',border:'1px solid #ddd',fontSize:'14px',marginBottom:'14px',boxSizing:'border-box'},
  tableWrap:{background:'white',borderRadius:'12px',overflow:'auto',border:'1px solid #eee'},
  table:{width:'100%',borderCollapse:'collapse'},
  thead:{background:'#2c3e50'},
  th:{padding:'12px 16px',color:'white',fontSize:'13px',fontWeight:'600',textAlign:'left'},
  td:{padding:'12px 16px',borderBottom:'1px solid #f0f0f0',fontSize:'14px'},
  empty:{textAlign:'center',padding:'30px',color:'#999'},
  editBtn:{background:'#3498db',color:'white',border:'none',padding:'6px 10px',borderRadius:'6px',cursor:'pointer',marginRight:'6px'},
  delBtn:{background:'#e74c3c',color:'white',border:'none',padding:'6px 10px',borderRadius:'6px',cursor:'pointer'},
};

export default Customers;
